import React from "react";

/** Bootstrap navbar family — Navbar, NavbarBrand, NavbarToggler. */

export const Navbar = ({ type = "light", expand, className = "", style, children, ...rest }) => {
  const cls = [
    "navbar",
    `navbar-${type}`,
    expand && `navbar-expand-${expand}`,
    className,
  ].filter(Boolean).join(" ");
  return (
    <nav className={cls} style={style} {...rest}>
      {children}
    </nav>
  );
};

export const NavbarBrand = ({ tag: Tag = "a", href, to, className = "", style, children, ...rest }) => {
  const cls = ["navbar-brand", className].filter(Boolean).join(" ");
  const linkProps = Tag === "a" ? { href } : { to };
  return (
    <Tag className={cls} style={style} {...linkProps} {...rest}>
      {children}
    </Tag>
  );
};

export const NavbarToggler = ({ onClick, className = "", ...rest }) => (
  <button
    type="button"
    className={["navbar-toggler", className].filter(Boolean).join(" ")}
    onClick={onClick}
    {...rest}
  >
    <span className="navbar-toggler-icon" />
  </button>
);
